import styled from "@emotion/styled";

import { fontSourceSerif4 } from "shared/lib/styles";

export const SectionTitle = styled.div`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const Container = styled.div`
  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;
